<template>
    <div>
        <buttonlist @reflash="reflash" @help="help"
                    ref="SetBtn"></buttonlist>
        <!--<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                        <el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" label="未审核人员"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Num" :label="$t('getapi[871]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Ver" :label="$t('getapi[113]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Type" :label="$t('getapi[134]')">
                                <template slot-scope="scope">
											<span v-if="scope.row.Item_Type==0">采购件</span>
                                            <span v-if="scope.row.Item_Type==1">外协件</span>
								</template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Reason" label="请示原因">
                                 <template slot-scope="scope">
											<span v-if="scope.row.Doc_Reason==0">降价</span>
                                            <span v-if="scope.row.Doc_Reason==1">换厂</span>
                                            <span v-if="scope.row.Doc_Reason==2">涨价</span>
                                            <span v-if="scope.row.Doc_Reason==3">其他</span>
								</template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Reason_Remark" label="请示原因其他备注"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status" :label="$t('getapi[552]')">
                                <template slot-scope="scope">
											<span v-if="scope.row.Status==0">生成</span>
                                            <span v-if="scope.row.Status==1">审核中</span>
                                            <span v-if="scope.row.Status==2">批准</span>
                                            <span v-if="scope.row.Status==3">驳回</span>
								</template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[1616]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[409]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_person" :label="$t('getapi[2591]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_time" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
                        </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div>
                    <div class="box" style="height: 35px;margin-top:5px">
                        <div class="bbl">
                            <span>项目代码</span>
                            <el-input type="text"  size="mini" style="width: 100px;"  v-model="dataDetail.Master.Item_Code" :disabled="true">
                            </el-input>
                            <span>供应商编码</span>
                            <el-input type="text"  size="mini" style="width: 100px;" v-model="dataDetail.Master.Vender_Code" :disabled="true">
                            </el-input>
                            <span>供应商名称</span>
                            <el-input  type="text" size="mini" style="width: 150px;"  v-model="dataDetail.Master.Vender_Name" :disabled="true"></el-input>
                            &lt;!&ndash;<span>货币单位</span>
                            <el-input  type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Master.Currency_Code" :disabled="true"></el-input>&ndash;&gt;
                        </div>
                    </div>
                    <div class="btnnowrap">
                        <el-button type="primary"  size="mini" @click="schQuotation(1)" :disabled="!btn.operate">同意</el-button>
                        <el-button type="primary"  size="mini" @click="reject" :disabled="!btn.operate">驳回</el-button>
                    </div>
                    <el-table
                            :data="dataDetail.DTlines"
                            ref="DTlinesTable"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            @selection-change="handleSelectionChange"
                            :height="tableHeight - 90"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" label="料号" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip label="币种" width="40">
                            <template>
                                {{dataDetail.Master.Currency_Code}}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" label="名称" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Pur_MeasurementUnit" label="单位" width="40"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Old_Unit_Price" label="目前单价" width="60" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="New_Unit_Price" label="请示单价" width="60" align="right"></el-table-column>
                        &lt;!&ndash;<el-table-column show-overflow-tooltip prop="price" label="批量含税价格" width="100" align="right"></el-table-column>&ndash;&gt;
                        <el-table-column show-overflow-tooltip prop="net_price" label="批量不含税价格" width="100" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="MOQ" label="MOQ1" width="50" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_floor_limit" label="MOQ2" width="50" align="right"></el-table-column>
                        &lt;!&ndash;<el-table-column show-overflow-tooltip prop="package_qty" label="订单增量" width="60" align="right"></el-table-column>&ndash;&gt;
                        <el-table-column show-overflow-tooltip prop="Shipment_Cycle" label="采购周期(天)" width="80" align="right"></el-table-column>
                        &lt;!&ndash;<el-table-column show-overflow-tooltip prop="material_price" label="当时材料价格" width="80" align="right"></el-table-column>&ndash;&gt;
                        <el-table-column show-overflow-tooltip prop="Remark" label="备注" width="100"></el-table-column>
                        &lt;!&ndash;<el-table-column show-overflow-tooltip prop="Cost_Std" label="标准成本" width="100" align="right"></el-table-column>&ndash;&gt;
                        &lt;!&ndash;<el-table-column show-overflow-tooltip prop="preferred_flag" label="是否首选供应商" width="100" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Effective_Date" label="有效期" width="130" ></el-table-column>&ndash;&gt;
                    </el-table>
                </div>
            </li>
        </ul>-->
        <div class="btnnowrap">
            <el-button type="primary"  size="mini" @click="schQuotation(1)" :disabled="!btn.operate">{{$t('getapi[6187]')}}</el-button>
            <el-button type="primary"  size="mini" @click="reject" :disabled="!btn.operate">{{$t('getapi[6228]')}}</el-button>
        </div>
        <el-table
                :data="dataDetail.DTlines"
                ref="DTlinesTable"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                @selection-change="handleSelectionChange"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:5px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Doc_Num" :label="$t('getapi[13393]')" width="150" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[8171]')" width="150" sortable></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[1176]')" width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Pur_MeasurementUnit" :label="$t('getapi[1166]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Old_Currency_Code" :label="$t('getapi[8168]')" width="40"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Old_Unit_Price" :label="$t('getapi[6442]')" width="60" align="right">

            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Old_Unit_Price_CB" :label="$t('getapi[12614]')" width="70" align="right" v-if="userData.Login_DB == 'MLXY'">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Old_Currency_Code_CB" :label="$t('getapi[12615]')" width="70" align="right" v-if="userData.Login_DB == 'MLXY'">
            </el-table-column>
            <el-table-column :label="$t('getapi[8172]')" width="70">
                <template slot-scope="scope" v-if="(scope.row.New_Unit_Price || scope.row.net_price) && scope.row.Old_Unit_Price">
                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) >= 0" style="color: red">{{getRiseAndFallRate(scope.row)}}%</span>
                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) < 0" style="color: #67C23A">{{Math.abs(getRiseAndFallRate(scope.row))}}%</span>
                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.New_Unit_Price / scope.row.Old_Unit_Price * 10000) / 100.00)-100).toFixed(2)}}%</span>
                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.net_price / scope.row.Old_Unit_Price * 10000) / 100.00) - 100).toFixed(2)}}%</span>
                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs( scope.row.Old_Unit_Price - scope.row.New_Unit_Price)/ scope.row.New_Unit_Price * 10000) / 100.00).toFixed(2)}}%</span>
                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs(scope.row.Old_Unit_Price - scope.row.net_price) / scope.row.net_price * 10000) / 100.00).toFixed(2)}}%</span>
                </template>
            </el-table-column>
            <el-table-column  prop="Pur_Price" :label="$t('getapi[8572]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="New_Currency_Code" :label="$t('getapi[8169]')" width="40"></el-table-column>
            <el-table-column prop="New_Unit_Price" :label="$t('getapi[8170]')" width="60" align="right">
                <template slot-scope="scope">
                    <span v-if="scope.row.Pur_Price != null && scope.row.New_Unit_Price>scope.row.Pur_Price" style="color: red">{{scope.row.New_Unit_Price}} </span>
                    <span v-else-if="scope.row.Pur_Price != null && scope.row.New_Unit_Price<scope.row.Pur_Price" style="color: #67C23A">{{scope.row.New_Unit_Price}} </span>
                    <span v-else>{{scope.row.New_Unit_Price}} </span>
                </template>
            </el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="price" label="批量含税价格" width="100" align="right"></el-table-column>-->
            <el-table-column prop="net_price" :label="$t('getapi[6732]')" width="100" align="right">
                <template slot-scope="scope">
                    {{scope.row.net_price | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="MOQ" label="MOQ1" width="50" align="right">
                <template slot-scope="scope">
                    {{scope.row.MOQ | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="batch_floor_limit" label="MOQ2" width="50" align="right">
                <template slot-scope="scope">
                    {{scope.row.batch_floor_limit | thousandth}}
                </template>
            </el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="package_qty" label="订单增量" width="60" align="right"></el-table-column>-->
            <el-table-column prop="Shipment_Cycle" :label="$t('getapi[1520]')" width="80" align="right">
                <template slot-scope="scope">
                    {{scope.row.Shipment_Cycle | thousandth}}
                </template>
            </el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="material_price" label="当时材料价格" width="80" align="right"></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')" width="100"></el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="Cost_Std" label="标准成本" width="100" align="right"></el-table-column>-->
            <!--<el-table-column show-overflow-tooltip prop="preferred_flag" label="是否首选供应商" width="100" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="Effective_Date" label="有效期" width="130" ></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="DUTY_PERSON" :label="$t('getapi[6403]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Effective_Date" :label="$t('getapi[7877]')" width="120"></el-table-column>
        </el-table>
        <el-dialog v-dialogDrag
            :title="$t('getapi[6472]')"
            :visible.sync="CloseDialogVisible"
            width="30%"
            >
            <el-input
            type="textarea"
            :rows="5"
            v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="schQuotation(2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
    export default {
        name: 'pricereqapprove',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user:[],
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    IsEdit:1,
                    Master:{},
                    DTAuditInfo:[],
                    DTlines:[]
                },
                CloseDialogVisible: false,
                resontxt: '',
                btn: {
                    operate: false
                },
                scrollTop:0,
                changeRateArr:[],
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            //that.authority();
            that.$limits.dragControllerDiv();
            that.getExchangeRate()
            that.getView()
            that.authority()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.DTlinesTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.DTlinesTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6541]"),this.$t("getapi[17]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('refresh');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.operate = false
                if(that.selectData.length > 0){
                    that.btn.operate = true
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = {
                    Exclusively_ID: '',
                    Item_Code: '',
                    Vender_Code: ''
                }
                that.$http.urlpost('/Sch/Quotation/SchQAuditInfoByAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.DTlines = res.DataContent.DTlines
                        that.loading = false;
                    }
                });
            },
            /*// 根据ID获取详情数据
            editInfo(row) {
                let that = this

                that.dataDetail.Master = {
                    Item_Code: row.Item_Code,
                    Vender_Code: row.Vender_Code,
                    Vender_Name: row.Vender_Name,
                    Currency_Code: row.Currency_Code
                }
                that.code = {
                    Item_Code: row.Item_Code,
                    Vender_Code: row.Vender_Code,
                    Vender_Name: row.Vender_Name
                }
                let parm = {
                    Exclusively_ID: row.Exclusively_ID,
                    Item_Code: row.Item_Code,
                    Vender_Code: row.Vender_Code
                }
                that.getDetail(parm);
            },
            getDetail(parm){
                let that = this
                that.$http.urlpost('/Sch/Quotation/SchQAuditInfoByAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.DTlines = res.DataContent.DTlines
                    }
                });
            },*/
            // 刷新
            reflash() {
                let that = this
                that.getView()
            },
            handleSelectionChange(val){
                let that = this
                that.selectData = []
                for(let i = 0;i<val.length;i++){
                    that.selectData.push(val[i])
                }
                that.btnauthority()
            },
            // 行同意，驳回
            schQuotation(val){
                let that = this
                let datetime = Common.methods.getDatetime()
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        Exclusively_ID: that.selectData[i].LineAuidtIID,
                        MainRelation_IID: that.selectData[i].MainRelation_IID,
                        Relation_IID: that.selectData[i].LineAuidtRelation_IID,
                        Sort: '',
                        userID: that.selectData[i].userid,
                        Audit_Person: that.user,
                        Audit_Status: val,
                        Audit_Date: datetime,
                        Audit_Msg: that.resontxt
                    }]
                }
                let parm = arr
                that.$http.urlpost('/api/SchQuotation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                        that.getView()
                    }
                });
            },
            // 驳回
            reject(){
                let that = this
                that.CloseDialogVisible = true
                that.resontxt = ''
            },
            //获取汇率信息
            getExchangeRate(){
                let that = this;
                let time = Common.methods.getDate()
                let datac = [];
                datac.push({
                    query_Condition: ">="+time,
                    query_field_type: 'date',
                    query_field_name: "invalid_date",
                    query_sort: "",
                    row_sign: ""
                });
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    Param: datac
                };
                that.$http.urlpost('Basic/General/GetExchangeRateList', data, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.changeRateArr = res.DataContent;
                    }
                });
            },
            getRiseAndFallRate(data){
                let that = this
                let oldprice = data.Old_Unit_Price;
                let newprice = data.New_Unit_Price;
                let netprice = data.net_price
                for(let i = 0;i<that.changeRateArr.length;i++){
                    if(data.Old_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        oldprice = that.changeRateArr[i].exchange_rate * data.Old_Unit_Price
                    }
                    if(data.New_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        newprice = that.changeRateArr[i].exchange_rate * data.New_Unit_Price
                        netprice = that.changeRateArr[i].exchange_rate * data.net_price
                    }
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) > 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) > 1){
                    return ((( oldprice - newprice)/ newprice * 10000) / 100.00).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) < 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) < 1){
                    return (((oldprice - netprice) / netprice * 10000) / 100.00).toFixed(2)
                }
            },
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
